'use client';

import React from 'react';







import { useAuth } from '@/contexts/AuthContext';

function DashboardSubtitle() {
  const { profile } = useAuth();
  const role = profile?.role;

  if (role === 'admin') return <span>Organisation overview — Wednesday, 23 July 2026</span>;
  if (role === 'manager') return <span>Team overview — Wednesday, 23 July 2026</span>;
  return <span>My workspace — Wednesday, 23 July 2026</span>;
}

function DashboardTitle() {
  const { profile } = useAuth();
  const role = profile?.role;
  const name = profile?.full_name?.split(' ')?.[0] || '';

  if (role === 'admin') return 'Home Dashboard';
  if (role === 'manager') return name ? `Welcome, ${name}` : 'Team Dashboard';
  return name ? `Welcome, ${name}` : 'My Dashboard';
}

export default function ComingSoonPage() {
  return (
    <main className="min-h-screen flex items-center justify-center bg-[#0f0f13] px-6">
      <div className="text-center max-w-xl">
        {/* Subtle glow orb */}
        <div
          aria-hidden="true"
          className="absolute inset-0 overflow-hidden pointer-events-none"
          style={{ zIndex: 0 }}
        >
          <div
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-20"
            style={{
              background:
                'radial-gradient(circle, #7c5cfc 0%, #3b1fa8 40%, transparent 70%)',
              filter: 'blur(80px)',
            }}
          />
        </div>

        <div className="relative z-10 space-y-6">
          {/* Eyebrow */}
          <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-purple-400 bg-purple-400/10 border border-purple-400/20 px-4 py-1.5 rounded-full">
            HR Yarn Pty Ltd
          </span>

          {/* Headline */}
          <h1
            className="text-4xl sm:text-5xl font-bold leading-tight relative z-50 pb-1"
            style={{
              fontFamily: "'DM Sans', sans-serif",
              background: 'linear-gradient(135deg, #ffffff 30%, #a78bfa 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            We&apos;ve got something exciting to announce!
          </h1>

          {/* Subtext */}
          <p
            className="text-lg text-slate-400 leading-relaxed"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Coming soon. Stay tuned!
          </p>

          {/* Decorative divider */}
          <div className="flex items-center justify-center gap-3 pt-2">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-purple-500/60" />
            <div className="w-1.5 h-1.5 rounded-full bg-purple-400" />
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-purple-500/60" />
          </div>
        </div>
      </div>
    </main>
  );
}